import { useEffect } from 'react';
import './App.css';
import Routes from './app/shared/routes';
import { Analytics } from '@vercel/analytics/react';
import { SpeedInsights } from "@vercel/speed-insights/react"
import { ToastContainer, LoadingOverlay } from './app/shared/components';
import { useThemeStore } from './app/shared/stores';

function App() {
  const { initializeTheme } = useThemeStore();

  // Inicializa o tema ao carregar a aplicação
  useEffect(() => {
    initializeTheme();
  }, [initializeTheme]);

  return (
    <div className="app">
      <Routes />
      <ToastContainer />
      <LoadingOverlay />
      <Analytics />
      <SpeedInsights />
    </div>
  );
}

export default App;

